export enum CategorySearchSortType {
  SequenceNumber = 'SequenceNumber',
  POS = 'POS',
  LastDay = 'LastDay',
  LastWeek = 'LastWeek',
  LastMonth = 'LastMonth',
  PriceHighest = 'PriceHighest',
  PriceLowest = 'PriceLowest',
  AlphabeticalAsc = 'AlphabeticalAsc',
  AlphabeticalDesc = 'AlphabeticalDesc',
  Date = 'Date',
}
